exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".App {\n  margin: 1rem;\n  font-family: Arial, Helvetica, sans-serif;\n}", ""]);
